import Modal from "react-modal";
import { BrowserRouter as Router } from "react-router-dom";
import { ApiContextProvider } from "./context/ApiContext";
import { ModalContextProvider } from "./context/ModalContext";
import FormSteps from "./form/steps";

// Bind modal to appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement("#midtown-memberships-root");

function App() {
	return (
		<Router>
			<ModalContextProvider>
				<ApiContextProvider>
					<FormSteps />
				</ApiContextProvider>
			</ModalContextProvider>
		</Router>
	);
}

export default App;
